/**
 * Date helpers for championship scheduling.
 *
 * Events are scheduled in Barbados local time but stored as UTC timestamps,
 * so every conversion has to go through here rather than the browser's own
 * timezone — a steward in another timezone would otherwise schedule races at
 * the wrong hour.
 */

export const TZ = 'America/Barbados';

export const TZ_OFFSET = -4;

// Barbados is UTC-4 (no DST)

/** Parse a datetime-local input value as Barbados time → UTC Date */
export function barbadosToUTC(str) {
  if (!str) return null;
  // Input is "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm" in Barbados time
  // new Date() parses date-only as UTC and datetime as local, so normalize:
  const iso = str.includes('T') ? str + ':00Z' : str + 'T00:00:00Z';
  const d = new Date(iso);
  // Subtract the offset to convert Barbados → UTC (UTC-4 means add 4h)
  d.setHours(d.getHours() - TZ_OFFSET);
  return d;
}

export function fmtDate(ts) {
  if (!ts) return '—';
  const d = ts?.toDate ? ts.toDate() : new Date(ts);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', timeZone: TZ });
}

export function fmtDateTime(ts) {
  if (!ts) return '—';
  const d = ts?.toDate ? ts.toDate() : new Date(ts);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString(undefined, {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: TZ,
  });
}

export function tsToLocal(ts) {
  if (!ts?.toDate) return '';
  const d = ts.toDate();
  // Convert UTC → Barbados time (UTC-4) for datetime-local input
  const barbados = new Date(d.getTime() + TZ_OFFSET * 60 * 60 * 1000);
  return barbados.toISOString().slice(0, 16);
}

/* ── Format date ── */
export function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
